export default __webpack_public_path__ + "static/ico-trash-42e444c215926527d97fdc98e043294c.svg";